import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ServiceDetail from "./components/ServiceDetail";
import BlogListing from "./components/BlogListing";
import BlogPost from "./components/BlogPost";
import Gallery from "./components/Gallery";
import SampleBrandPage from "./components/SampleBrandPage";
import AdminSMS from "./components/AdminSMS";
import { Toaster } from "./components/ui/sonner";
import { Toaster as ShadcnToaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          {/* SEO-friendly short URLs for the 6 primary services */}
          <Route path="/ev-charger-installation-brooklyn" element={<ServiceDetail slug="ev-charger-installation" />} />
          <Route path="/panel-upgrade-brooklyn" element={<ServiceDetail slug="electrical-panel-upgrades" />} />
          <Route path="/generator-installation-brooklyn" element={<ServiceDetail slug="generator-installation" />} />
          <Route path="/smart-home-wiring-brooklyn" element={<ServiceDetail slug="smart-home-system-installation" />} />
          <Route path="/emergency-electrician-brooklyn" element={<ServiceDetail slug="emergency-repairs" />} />
          <Route path="/christmas-light-installation-brooklyn" element={<ServiceDetail slug="christmas-light-installation" />} />

          {/* Legacy nested URLs kept for backward compat with existing links & sitemap */}
          <Route path="/services/:slug" element={<ServiceDetail />} />

          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/brand-sample" element={<SampleBrandPage />} />
          <Route path="/admin/sms" element={<AdminSMS />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <ShadcnToaster />
    </div>
  );
}

export default App;
